import { StopPointHelper } from '../../../helpers/stop-point.helper';
import type { IStopPoint } from '../../../models/stop-point.model';

export class StopPointApiModel {
  public static mapToBusinessModel(apiModel: StopPointApiModel): IStopPoint {
    return {
      gid: apiModel.gid,
      name: apiModel.name,
      platform: apiModel.platform,
      latitude: apiModel.latitude,
      longitude: apiModel.longitude,
      municipality: { gid: '', name: apiModel.municipalityName },
      isFlexibleTaxiService: apiModel.isFlexibleTaxiService,
      stopPointType: StopPointHelper.mapToStopPointType(apiModel.stopPointType),
    };
  }

  public gid!: string;
  public name!: string;
  public latitude!: number;
  public longitude!: number;
  public municipalityName!: string;
  public platform!: string;
  public isFlexibleTaxiService!: boolean;
  public stopPointType!: string;
}
